import React,{useEffect} from 'react'
import {connect} from 'react-redux'
import { Container ,Row,Col} from 'reactstrap'


import {setCurrenttab_joinme} from '../../Actions/Actionexport'
import JoinmeForm from '../joinmeForm'
import backimage from '../../Resources/Images/pexels-tima-miroshnichenko-5380673.jpg'

const Joinme=(props)=>{
    useEffect(()=>{
        props.setCurrenttab_joinme()
      },[props])
    return(
        <Container fluid={true}  style={{backgroundImage: "url(" + backimage + ")",height:'700px',width:'100%'}}>
            <Row  >
                <Col className="mt-5  " style={{color:'white'}}>
                Are you good at coding /animation /digital art /music creation /content writing?<br></br>
                Wanna join my journey of developing awesome games and web apps?<br></br>
                </Col>
            </Row>
            <Row>
                <Col className="mt-5">
                <JoinmeForm></JoinmeForm>
                </Col>
            
            </Row>
        </Container>
    )
}

const mapdispatchtomethod=(dispatch)=>{
    return{
        setCurrenttab_joinme:()=>dispatch(setCurrenttab_joinme())
    }
}
export default connect(null,mapdispatchtomethod)(Joinme) 